export default __webpack_public_path__ + "static/media/Kalimati.23e610a1.ttf";